<!--
 * @Author: M.D.
 * @Date: 2019-12-26 14:23:36
 * @LastEditors  : M.D.
 * @Description: 验证码
 * @Remarks:
 -->
<template>
  <div class="auth-code-c">
    <el-input  placeholder="请输入验证码" type="text" v-model="authCode" @input="valChange">
      <el-button
        @click="getCode"
        :disabled="canReGet"
        :loading="btnLoading"
        class="auth-code-btn"
        type="primary"
        slot="append">{{tipText}} <span v-show="canReGet" class="count">{{count}}</span>
      </el-button>
    </el-input>
  </div>
</template>

<script>
import API from '@/api/api'
import { phone } from '@/util/rule'

const TIME_COUNT = 60

export default {
  props: {
    phoneNum: {
      default: '',
      type: String
    },
    isReg: {
      default: true,
      type: Boolean
    },
    isForget: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      btnLoading: false,
      authCode: '',
      tipText: '获取验证码',
      count: '',
      canReGet: false,
      timer: null
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {

  },
  watch: {
    isForget (v) {
      if (v) {
        this.isReg = false
      }
    }
  },
  methods: {
    clearValue () {
      this.authCode = ''
    },
    async getCode () {
      if (this._.isEmpty(this.phoneNum)) {
        this.$message('请输入手机号码')
        return
      }
      this.$emit('onReceving')
      phone(null, this.phoneNum, async (err) => {
        if (err) {
          this.$message('输入的手机号码有误，请检查后重试')
        } else {
          this.btnLoading = true
          try {
            let re = {}
            if (this.isForget) {
              re = await API.forgetAuthCode({
                mobile: this.phoneNum
              })
            } else {
              re = await API.getAuthCode({
                isReg: this.isReg,
                mobile: this.phoneNum
              })
            }
            this.btnLoading = false
            if (re.data.statusCode === '200') {
              this.$message({
                message: '验证码发送成功',
                type: 'success'
              })
              this.startCountDown()
            } else {
              this.$message('验证码发送失败，请稍后重试')
            }
          } catch {
            this.btnLoading = false
          }
        }
      })
    },
    startCountDown () {
      if (!this.timer) {
        this.count = TIME_COUNT
        this.tipText = '再次获取'
        this.canReGet = true
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.canReGet = false
            clearInterval(this.timer)
            this.timer = null
            this.tipText = '获取验证码'
          }
        }, 1000)
      }
    },
    valChange (newVal) {
      this.$emit('authCodeChange', newVal)
    }
  },
  components: {

  }
}
</script>

<style lang="stylus">
.auth-code-c
// 重写element按钮样式
  .el-input-group__append
    .auth-code-btn
      background-color theme-color
      color #ffffff
      &.is-disabled
        opacity 0.5
        color #111111
        background-color transparent
</style>
